import Joi from '@hapi/joi'

export const OperationentityProductMappingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    productID: Joi.number().required().label("Product").messages({
        "any.invalid": `Product cannot have invalid characters`,
        "any.required": `Product required`
    }),
    isActive: Joi.boolean().label("Active"),
}